import { SafeUrl } from '@angular/platform-browser';

export enum Status {
  Available = 'Available',
  AvailableIdle = 'AvailableIdle',
  Away = 'Away',
  BeRightBack = 'BeRightBack',
  Busy = 'Busy',
  BusyIdle = 'BusyIdle',
  DoNotDisturb = 'DoNotDisturb',
  Offline = 'Offline',
  PresenceUnknown = 'PresenceUnknown',
}

export interface GraphUserInfo {
  id: string;
  displayName: string;
  givenName?: string;
  jobTitle: string;
  mail: string;
  userPrincipalName: string;
  requestId: string;
}

export interface GraphUserPhoto {
  requestId: string;
  picture: SafeUrl;
}

export interface GraphUserPresence {
  requestId: string;
  presence: Status;
}

export type GraphUser = GraphUserInfo & GraphUserPhoto & GraphUserPresence;
